(() => {
  const SELECTORS = {
    table: '.variant-table',
    tableRow: '.variant-table__row',
    addBtn: '.variant-table__add',
    qtyInput: '.variant-table__qty-input',
    msg: '.variant-table__msg',
    cartBubble: '.cart-count-bubble span[aria-hidden="true"]',
    productForm: 'form[action*="/cart/add"]',
    variantIdInput: 'input[name="id"]',
    stickyBar: '.mobile-sticky-cta',
    stickyBtn: '[data-sticky-add]',
  };

  // ---------- CART ----------
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();

      const bubble = document.querySelector(SELECTORS.cartBubble);
      if (bubble) bubble.textContent = String(cart.item_count);
    } catch (e) {}
  }

  async function addToCart(variantId, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty) }),
    });

    if (!res.ok) {
      let msg = 'Errore durante aggiunta al carrello';
      try {
        const data = await res.json();
        msg = data?.description || data?.message || msg;
      } catch (e) {}
      throw new Error(msg);
    }

    return res.json();
  }

  // ---------- HELPERS ----------
  function getSelectedVariantId(form) {
    const idInput = form.querySelector(SELECTORS.variantIdInput);
    return idInput ? String(idInput.value) : null;
  }

  function getSectionIdFromForm(form) {
    return form?.dataset?.sectionId || form?.getAttribute('data-section-id');
  }

  function parseSize(value) {
    if (!value) return Number.POSITIVE_INFINITY;
    const cleaned = String(value)
      .toLowerCase()
      .replace(',', '.')
      .replace(/[^0-9.]/g, '');
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
  }

  function sortVariantTableByOption1(root = document) {
    root.querySelectorAll('.variant-table__table').forEach((table) => {
      const tbody = table.querySelector('tbody');
      if (!tbody) return;

      const rows = Array.from(tbody.querySelectorAll(SELECTORS.tableRow));
      rows.sort((a, b) => parseSize(a.dataset.option1) - parseSize(b.dataset.option1));
      rows.forEach((r) => tbody.appendChild(r));
    });
  }

  // ---------- HIGHLIGHT (dropdown -> table) ----------
  function highlightSelectedVariantRow(form) {
    const variantId = getSelectedVariantId(form);
    if (!variantId) return;

    const sectionRoot = form.closest('[id^="shopify-section-"]') || document;
    const table = sectionRoot.querySelector(SELECTORS.table) || document.querySelector(SELECTORS.table);
    if (!table) return;

    table.querySelectorAll(SELECTORS.tableRow).forEach((r) => r.classList.remove('is-selected'));
    const activeRow = table.querySelector(`${SELECTORS.tableRow}[data-variant-id="${variantId}"]`);
    if (activeRow) activeRow.classList.add('is-selected');
  }

  // ---------- SYNC INVERSE (table -> dropdown) ----------
  function selectVariantInPickerFromRow(row) {
    // se esaurito, non selezionare
    if (row.classList.contains('is-soldout')) return;

    const sectionRoot = row.closest('[id^="shopify-section-"]') || document;
    const form = sectionRoot.querySelector(SELECTORS.productForm);
    if (!form) return;

    const opt1 = row.dataset.option1;
    const opt2 = row.dataset.option2;
    const opt3 = row.dataset.option3;

    // 1) Dropdown select (options[...])
    const selects = Array.from(form.querySelectorAll('select[name^="options["]'));
    if (selects.length) {
      if (selects[0] && opt1 != null) selects[0].value = opt1;
      if (selects[1] && opt2 != null) selects[1].value = opt2;
      if (selects[2] && opt3 != null) selects[2].value = opt3;

      selects.forEach((s) => s.dispatchEvent(new Event('change', { bubbles: true })));
      return;
    }

    // 2) Radio (fieldset)
    const fieldsets = Array.from(form.querySelectorAll('fieldset'));
    const desired = [opt1, opt2, opt3].filter((v) => v != null && v !== '');

    desired.forEach((val, idx) => {
      const fs = fieldsets[idx];
      if (!fs) return;

      const radio = fs.querySelector(`input[type="radio"][value="${CSS.escape(val)}"]`);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // ---------- STICKY CTA ----------
  function updateStickyPrice(sectionId, priceText) {
    const el = document.getElementById(`StickyPrice-${sectionId}`);
    if (el && priceText) el.textContent = priceText;
  }

  function readDisplayedPrice(sectionId) {
    // legge il prezzo già renderizzato (formatting Shopify)
    const priceEl =
      document.querySelector(`#price-${sectionId} .price__regular .price-item--regular`) ||
      document.querySelector(`#price-${sectionId} .price-item--regular`);
    return priceEl ? priceEl.textContent.trim() : '';
  }

  function bindStickyCta(root = document) {
    root.querySelectorAll(SELECTORS.stickyBar).forEach((bar) => {
      if (bar.dataset.bound === '1') return;
      bar.dataset.bound = '1';

      const sectionId = bar.dataset.sectionId;
      const sectionRoot = document.querySelector(`#shopify-section-${sectionId}`) || document;

      bar.addEventListener('click', (e) => {
        const btn = e.target.closest(SELECTORS.stickyBtn);
        if (!btn) return;

        // clicka il bottone vero di Dawn (submit add)
        const realBtn = sectionRoot.querySelector('button[name="add"]');
        if (realBtn) realBtn.click();
      });
    });
  }

  // ---------- BIND TABLE ----------
  function bindTable(tableEl) {
    if (tableEl.dataset.vtBound === '1') return;
    tableEl.dataset.vtBound = '1';

    // Click sul bottone "Aggiungi" (riga)
    tableEl.addEventListener('click', async (e) => {
      const btn = e.target.closest(SELECTORS.addBtn);
      if (!btn) return;

      const row = btn.closest(SELECTORS.tableRow);
      if (!row) return;

      const msg = row.querySelector(SELECTORS.msg);
      const input = row.querySelector(SELECTORS.qtyInput);

      const variantId = btn.dataset.variantId;
      const qty = Math.max(1, parseInt(input?.value || '1', 10));

      btn.disabled = true;
      if (msg) msg.textContent = 'Aggiungo...';

      try {
        await addToCart(variantId, qty);
        if (msg) msg.textContent = 'Aggiunto ✅';
        await refreshCartCount();
      } catch (err) {
        if (msg) msg.textContent = err?.message || 'Errore';
      } finally {
        btn.disabled = false;
      }
    });

    // Click sulla riga -> seleziona variante nel dropdown (sync inverso)
    tableEl.addEventListener('click', (e) => {
      if (e.target.closest(SELECTORS.addBtn)) return;
      if (e.target.closest(SELECTORS.qtyInput)) return;

      const row = e.target.closest(SELECTORS.tableRow);
      if (!row) return;

      selectVariantInPickerFromRow(row);
    });
  }

  // ---------- BIND FORM SYNC ----------
  function bindFormSync(form) {
    if (form.dataset.vtFormBound === '1') return;
    form.dataset.vtFormBound = '1';

    // prima evidenzia
    highlightSelectedVariantRow(form);

    // quando cambia qualsiasi opzione nel form
    form.addEventListener('change', () => {
      highlightSelectedVariantRow(form);

      const sectionId = getSectionIdFromForm(form);
      if (sectionId) {
        const priceText = readDisplayedPrice(sectionId);
        if (priceText) updateStickyPrice(sectionId, priceText);
      }
    });
  }

  // Dawn spesso emette variant:change (dipende dalla versione)
  function bindVariantChangeEvent() {
    if (document.documentElement.dataset.vtVariantChangeBound === '1') return;
    document.documentElement.dataset.vtVariantChangeBound = '1';

    document.addEventListener('variant:change', (e) => {
      const form = e.target?.closest?.(SELECTORS.productForm);
      if (!form) return;

      highlightSelectedVariantRow(form);

      const sectionId = getSectionIdFromForm(form);
      if (sectionId) {
        const priceText = readDisplayedPrice(sectionId);
        if (priceText) updateStickyPrice(sectionId, priceText);
      }
    });
  }

  // ---------- INIT ----------
  function init(root = document) {
    root.querySelectorAll(SELECTORS.table).forEach(bindTable);
    document.querySelectorAll(SELECTORS.productForm).forEach(bindFormSync);

    sortVariantTableByOption1(root);
    bindStickyCta(root);
    bindVariantChangeEvent();

    // aggiorna sticky price subito al load
    document.querySelectorAll(SELECTORS.productForm).forEach((form) => {
      const sectionId = getSectionIdFromForm(form);
      if (sectionId) {
        const priceText = readDisplayedPrice(sectionId);
        if (priceText) updateStickyPrice(sectionId, priceText);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
